"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import styles from "./product.module.css";
import {
  Footer,
  FAQ,
  ReversibleComponent,
  ReverseText,
  ProductHero,
} from "../../../components";
import {
  appstorebtn,
  googleplaybtn,
  estateheader,
  productImage1,
  productImage2,
  productImage3,
} from "../../../assets";
import {
  productbenefitsOfCommunity,
  productCarouselItems,
} from "../../../utils/index";

const Product = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const intervalTime = 5000;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(
        (prevIndex) => (prevIndex + 1) % productCarouselItems.length
      );
    }, intervalTime);

    return () => clearInterval(interval);
  }, [intervalTime]);

  const handleCarouselClick = (index) => {
    setCurrentIndex(index);
  };

  const currentItem = productCarouselItems[currentIndex];
  return (
    <main className={styles.estatemain}>
      <ProductHero />
      <div className={styles.getstartedwithproduct}>
        <div className={styles.thirdFramebadge_title}>
          <span className={styles.thirdFramebadge}>get started</span>
        </div>
        <p className={styles.getstartedwithproduct_description}>
          CirclePlug’s product and invoicing management system is designed to
          handle all back store, front store, and inventory operations. It
          caters to a all business types, providing a simple solution to
          streamline processes, improve efficiency, and enhance customer
          satisfaction.
        </p>
      </div>
      <div className={styles.estatesecondFrame}>
        <div className={styles.estatereverse}>
          <ReversibleComponent
            leftElement={
              <ReverseText
                badge="Products"
                lowercasebadge={true}
                heading="Product Management"
                reversetextsmallbadge={styles.reversetextsmallbadge}
                reversetextsmallheading={styles.reversetextsmallheading}
                reversetextsmalldescription={styles.reversetextsmalldescription}
                description={
                  <div className={styles.productmanagement}>
                    <p>
                      <strong>Overview:</strong> Centralized dashboard to manage
                      product details, pricing, and availability
                    </p>

                    <p>
                      <strong>Products:</strong> Comprehensive database to list
                      all products/services with descriptions and images.
                    </p>

                    <p>
                      <strong>Category:</strong> Easy categorization of
                      products/services for efficient organization and quick
                      access.
                    </p>
                  </div>
                }
              />
            }
            rightElement={
              <Image
                src={productImage1}
                alt="gate pass"
                width={596.3}
                height={582}
              />
            }
            reverseStyles={styles.reverseStyles}
            estaterow={styles.estaterow}
          />
        </div>
        <div className={styles.estatereverse}>
          <ReversibleComponent
            leftElement={
              <ReverseText
                badge="Feature"
                lowercasebadge={true}
                heading="Inventory Management"
                reversetextsmallbadge={styles.reversetextsmallbadge}
                reversetextsmallheading={styles.reversetextsmallheading}
                reversetextsmalldescription={styles.reversetextsmalldescription}
                description={
                  <div className={styles.productmanagement}>
                    <p>
                      <strong>Back store:</strong> Real-time tracking of
                      inventory levels, automated reorder alerts, and supplier
                      management.
                    </p>

                    <p>
                      <strong>Orders:</strong> Seamless handling of orders from
                      multiple channels (online, in-store, mobile).
                    </p>

                    <p>
                      <strong>Receipts:</strong> Automated receipt generation
                      for both digital and printed formats.
                    </p>
                  </div>
                }
              />
            }
            rightElement={
              <Image
                src={productImage2}
                alt="inventory management"
                width={597}
                height={570}
              />
            }
            reverseStyles={styles.reverseStyles}
            isReversed={true}
            estaterow={styles.estaterow}
          />
        </div>
        <div className={styles.estatereverse}>
          <ReversibleComponent
            leftElement={
              <ReverseText
                badge="Feature"
                lowercasebadge={true}
                heading="Order and Sales Management"
                reversetextsmallbadge={styles.reversetextsmallbadge}
                reversetextsmallheading={styles.reversetextsmallheading}
                reversetextsmalldescription={styles.reversetextsmalldescription}
                description={
                  <div className={styles.productmanagement}>
                    <p>
                      <strong>Order Creation:</strong> Customizable menus,
                      service packages, promotions, and discount codes.
                    </p>

                    <p>
                      <strong>Store Settings:</strong> Flexible configuration
                      options for POS systems, online integration, and customer
                      profiles.
                    </p>

                    <p>
                      <strong>Receipts:</strong> Detailed, itemized receipts to
                      enhance transparency and customer trust
                    </p>
                  </div>
                }
              />
            }
            rightElement={
              <Image
                src={productImage3}
                alt="resident ID"
                width={597}
                height={570}
              />
            }
            reverseStyles={styles.reverseStyles}
            estaterow={styles.estaterow}
          />
        </div>
      </div>

      <div className={styles.estatethirdFrame}>
        <div className={styles.estatetrials}>
          <div
            className={`${styles.estatethirdFrameImagebox} ${styles.estateImagebox}`}
          >
            <Image
              src={estateheader}
              alt="Manage it all and boost your business"
              className={styles.img}
              width={"100%"}
              height={"100%"}
            />
          </div>

          <div className={styles.estatebenefitcontainer}>
            <div className={styles.estatebenefitheadingwrapper}>
              <p
                className={styles.estatebenefitsheading}
                style={{ textTransform: "capitalize" }}
              >
                Manage it all and boost your business
              </p>
            </div>
            <div className={styles.estateCommunitycontainer}>
              {productbenefitsOfCommunity.map(({ id, icon, title, desc }) => (
                <div key={id} className={styles.estatebenefitofcommunity}>
                  <span className={styles.communityIconbox}>{icon}</span>
                  <p className={styles.benefitofcommunitytext}>{title}</p>
                  <p className={styles.benefitofcommunitytextbottom}>{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.estatefourthFrame}>
        <p className={styles.imagecarouseltitle}>
          A full solution to manage & grow your business
        </p>
        <div>
          <div className={styles.estatecarouselwithindicator}>
            <div className={styles.carouseltop}>
              <div className={styles.carouseltopleft}>
                <ul className={styles.carouseltextList}>
                  {productCarouselItems.map((item, index) => (
                    <li
                      key={item.id}
                      className={`${styles.carouseltextItem} ${
                        index === currentIndex ? styles.acarouselctiveText : ""
                      }`}
                      onClick={() => handleCarouselClick(index)}
                    >
                      {item.title}
                    </li>
                  ))}
                </ul>
              </div>
              <div className={styles.carouseltopright}>
                <div className={styles.carouseltopright_image}>
                  <Image
                    src={currentItem.image}
                    alt={currentItem.title}
                    className={styles.img}
                  />
                </div>

                <div className={styles.carouseltopright_desc}>
                  <span className={styles.descriptionTitle}>
                    {currentItem.descriptionTitle}
                  </span>
                  {currentItem.description}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.carouselbottom}>
            {productCarouselItems.map((item, index) => (
              <span
                key={item.id}
                className={`${styles.indicator} ${
                  index === currentIndex ? styles.activeIndicator : ""
                }`}
              ></span>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.fifthFrame}>
        <div className={styles.thirdFramewrapper}>
          <div className={styles.thirdFrametop}>
            <div className={styles.thirdFramebadge_title}>
              <span className={styles.thirdFramebadge}>get started</span>
              <p className={styles.thirdFrame_title}>
                Carry your accounts wherever you go! Download our App
              </p>
            </div>
            <p className={styles.thirdFrame_description}>
              Start your journey to empowering your community with our one stop
              app for building, engaging, and empowering your community
            </p>
          </div>
          <div className={styles.thirdFramebottom}>
            <div className={styles.platformbuttons}>
              <Link
                target={"_blank"}
                className={styles.platformbutton}
                href={`https://apps.apple.com/ng/app/circleplug/id6462672418`}
              >
                <Image src={appstorebtn} alt="app store button" />
              </Link>
              <Link
                target={"_blank"}
                className={styles.platformbutton}
                href={`https://play.google.com/store/apps/details?id=com.shypes.circlePlug`}
              >
                <Image src={googleplaybtn} alt="google play button" />
              </Link>
            </div>
          </div>
        </div>

        <div className={styles.sixthFrame}>
          <div className={styles.fourthFramewrapper}>
            <FAQ />
          </div>
        </div>
        <div className={styles.estatefooter}>
          <Footer />
        </div>
      </div>
    </main>
  );
};

export default Product;
